import { render } from "./SessionSelectTeam.vue?vue&type=template&id=97f6a014&scoped=true"
import script from "./SessionSelectTeam.vue?vue&type=script&lang=js"
export * from "./SessionSelectTeam.vue?vue&type=script&lang=js"

import "./SessionSelectTeam.vue?vue&type=style&index=0&id=97f6a014&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f6a014"]])

export default __exports__